import { ISetting } from "../domain/setting.interface";
import { instanceBo } from "../utils/axios.create";

const getSettings = async (): Promise<ISetting> => {
	return instanceBo
		.get("/settings?application=backoffice")
		.then((res) => {
			return res.data.body;
		})
		.catch((err) => {
			return Promise.reject(err.response.data);
		});
};

export const settingService = {
	getSettings,
};
